const modalMixin = {
  props: {
    isFullscreen: {
      type: Boolean,
      default: false
    },
    order: {
      type: Number,
      default: 1
    }
  },
  methods: {
    closeModal () {
      this.$emit('onCloseModal')
    }
  },
  mounted () {
    if (this.isFullscreen) {
      if (this.order === 1) {
        document.body.style.overflow = 'hidden'
      }
      if (this.order > 1) {
        this.$parent.$el.style.overflow = 'hidden'
      }
    }
    this.$el.style.overflow = 'auto'
  },
  beforeDestroy () {
    if (this.isFullscreen) {
      this.$el.style.overflow = 'hidden'
      if (this.order === 1) {
        document.body.style.overflow = 'auto'
      }
      if (this.order >= 2) {
        this.$parent.$el.style.overflow = 'auto'
      }
    }
  }
}
export default modalMixin
